import React from 'react';
import { PageLayout } from '../components/global/PageLayout';
import { CTABlock } from '../components/ui/CTABlock';
import { HeroSection } from '../components/LowOnFuel/sections/HeroSection';
import { AboutSection } from '../components/LowOnFuel/sections/AboutSection';
import { EventsPreview } from '../components/LowOnFuel/sections/EventsPreview';
import { FoodPreview } from '../components/LowOnFuel/sections/FoodPreview';
import { ShopPreview } from '../components/LowOnFuel/sections/ShopPreview';
import { GalleryPreview } from '../components/LowOnFuel/sections/GalleryPreview';
import { PAGE_META } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

/**
 * P01 — the home page. Each section is a preview that hands off to the page
 * that owns that subject, so nothing here is the only place a thing lives.
 */
export function Home() {
  useDocumentMeta({
    ...PAGE_META.home,
    path: '/'
  });
  return <PageLayout data-id="element-672" data-mp="3ovkhry47509v">
      <HeroSection data-id="element-673" data-mp="3ov2guo6l9xvm" />
      <AboutSection data-id="element-674" data-mp="3oyq6hc8wy052" />
      <EventsPreview data-id="element-675" data-mp="30xb8m1lj0tvo" />
      <FoodPreview data-id="element-676" data-mp="30vqf8fay7gze" />
      <ShopPreview data-id="element-677" data-mp="30w9mn22z2mz6" />
      <GalleryPreview data-id="element-678" data-mp="30uoypvb5y2aa" />
      {/* The CTA block is always last before the footer, so the page never
          ends on a section. */}
      <CTABlock data-id="element-679" data-mp="2qy2hdgi1ptd0" />
    </PageLayout>;
}